import React, { useState } from "react";
import { Breadcrumb, Button, Dropdown } from "react-bootstrap";
import { MdKeyboardArrowRight } from "react-icons/md";
import { FaHome } from "react-icons/fa";
import { RiHome6Line, RiArrowRightSLine } from "react-icons/ri";
import { HiOutlineViewGrid } from "react-icons/hi";
import { FiList, FiUpload, FiPlusCircle, FiChevronUp } from "react-icons/fi";
import PlansSummary from "../../components/super-admin/Packages/PlansSummary";
import PlansList from "../../components/super-admin/Packages/PlansList";
import {
  Card,
  Table,
  // Dropdown,
  Modal,
  // Button,
  Form,
  Row,
  Col,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import AddNewPlanModal from "../../components/modals/dashboard/packages/AddNewPlanModal";
const PackagesPages = () => {
  const [view, setView] = useState("list");

  const [selectedPlan, setSelectedPlan] = useState(null);
const [addNewPlan, setAddNewPlan] = useState(false);

  // const [addNewPlan, setAddNewPlan] = useState(true);

  const [profileImage, setProfileImage] = useState(
    "/assets/img/agents/agent-01.jpg",
  );
  const [selectedFile, setSelectedFile] = useState(null);

  // Plans state
  const [plans, setPlans] = useState([
    {
      id: 1,
      name: "Basic",
      type: "Monthly",
      subs: 56,
      price: "$50",
      date: "14 Jan 2024",
      status: "Active",
    },
    {
      id: 2,
      name: "Advanced",
      type: "Monthly",
      subs: 99,
      price: "$200",
      date: "21 Jan 2024",
      status: "Active",
    },
    {
      id: 3,
      name: "Premium",
      type: "Monthly",
      subs: 58,
      price: "$300",
      date: "10 Feb 2024",
      status: "Active",
    },
    {
      id: 4,
      name: "Enterprise",
      type: "Monthly",
      subs: 67,
      price: "$400",
      date: "18 Feb 2024",
      status: "Active",
    },
    {
      id: 5,
      name: "Basic",
      type: "Yearly",
      subs: 78,
      price: "$600",
      date: "15 Mar 2024",
      status: "Active",
    },
    {
      id: 6,
      name: "Advanced",
      type: "Yearly",
      subs: 99,
      price: "$2400",
      date: "26 Mar 2024",
      status: "Active",
    },
    {
      id: 7,
      name: "Premium",
      type: "Yearly",
      subs: 48,
      price: "$3600",
      date: "05 Apr 2024",
      status: "Active",
    },
    {
      id: 8,
      name: "Enterprise",
      type: "Yearly",
      subs: 17,
      price: "$4800",
      date: "16 Apr 2024",
      status: "Active",
    },
  ]);

  // Form state for Add Plan modal
const [planFormData, setPlanFormData] = useState({
  name: "",
  type: "Monthly",
  position: "",
  currency: "USD",
  limitInvoices: "",
  maxCustomers: "",
  product: "",
  supplier: "",
  price: "0",
  discountType: "Fixed",
  discount: "",
  trialDays: "",
  isRecommended: false,
  accessTrial: false,
  status: "Active",
  description: "",
  modules: [],           // ← Added for Plan Modules
});

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      setSelectedFile(file);
      setProfileImage(URL.createObjectURL(file));
    }
  };

  const handleCancelImage = () => {
    setProfileImage("/assets/img/agents/agent-01.jpg");
    setSelectedFile(null);
  };

  const handleFormChange = (e) => {
    const { name, value, type, checked } = e.target;
    setPlanFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleAddPlan = () => {
    // Create new plan object
    const newPlan = {
      id: Math.max(...plans.map((p) => p.id), 0) + 1,
      name: planFormData.name,
      type: planFormData.type,
      subs: 0,
      price: planFormData.price.startsWith("$")
        ? planFormData.price
        : "$" + planFormData.price,
      date: new Date().toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "2-digit",
      }),
      status: planFormData.status,
      position: planFormData.position,
      currency: planFormData.currency,
      limitInvoices: planFormData.limitInvoices,
      maxCustomers: planFormData.maxCustomers,
      product: planFormData.product,
      supplier: planFormData.supplier,
      discountType: planFormData.discountType,
      discount: planFormData.discount,
      trialDays: planFormData.trialDays,
      isRecommended: planFormData.isRecommended,
      accessTrial: planFormData.accessTrial,
      description: planFormData.description,
      image: selectedFile ? profileImage : null,
    };

    // Add to plans array
    setPlans([...plans, newPlan]);

    // Reset form
    setPlanFormData({
      name: "",
      type: "Monthly",
      position: "",
      currency: "USD",
      limitInvoices: "",
      maxCustomers: "",
      product: "",
      supplier: "",
      price: "0",
      discountType: "Fixed",
      discount: "",
      trialDays: "",
      isRecommended: false,
      accessTrial: false,
      status: "Active",
      description: "",
    });

    // Reset image
    setProfileImage("/assets/img/agents/agent-01.jpg");
    setSelectedFile(null);

    // Close modal
    setAddNewPlan(false);
  };
  return (
    <div
      style={{
        background: "#f5f6f8",
        padding: "15px 20px",
        borderRadius: "6px",
      }}
    >
      <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
        {/* LEFT SECTION */}
        <div className="my-auto mb-2">
          <h4 style={{ fontWeight: "600", marginBottom: "5px" }}>Packages</h4>

          <Breadcrumb
            style={{
              background: "transparent",
              padding: 0,
              margin: 0,
              fontSize: "14px",
            }}
          >
            <Breadcrumb.Item>
              <RiHome6Line
                className="mb-1 text-dark"
                style={{
                  fontSize: "1.2rem", // increased icon size
                  verticalAlign: "middle",
                  marginRight: "0.35rem",
                }}
              />
            </Breadcrumb.Item>

            <MdKeyboardArrowRight className="mt-1 fs-5" />

            <Breadcrumb.Item
              linkAs="span"
              className="text-dark text-decoration-none fs-6"
            >
              Super Admin
            </Breadcrumb.Item>

            <MdKeyboardArrowRight className="mt-1 fs-5" />

            <Breadcrumb.Item active>
              <span className="text-dark fs-6">Packages List</span>
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>

        {/* RIGHT SECTION */}
        <div className="d-flex align-items-center flex-wrap">
          {/* LIST / GRID TOGGLE */}
          <div
            className="d-flex align-items-center me-2 mb-2"
            style={{
              border: "1px solid #e5e7eb",
              background: "#fff",
              borderRadius: "8px",
              padding: "4px",
            }}
          >
            {/* LIST BUTTON */}
            <Link className="text-decoration-none" to="/packages-pages">
              <Button
                size="sm"
                onClick={() => setView("list")}
                style={{
                  background: view === "list" ? "#f97316" : "transparent",
                  border: "none",
                  marginRight: "4px",
                  width: "36px",
                  height: "32px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: view === "list" ? "#fff" : "#6b7280",
                }}
              >
                <FiList size={16} />
              </Button>
            </Link>

            {/* GRID BUTTON */}
            <Link className="text-decoration-none" to="/packages-cp-pages">
              <Button
                size="sm"
                onClick={() => setView("grid")}
                style={{
                  background: view === "grid" ? "#f97316" : "transparent",
                  border: "none",
                  width: "36px",
                  height: "32px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: view === "grid" ? "#fff" : "#6b7280",
                }}
              >
                <HiOutlineViewGrid size={16} />
              </Button>
            </Link>
          </div>

          {/* EXPORT */}
          <Dropdown className="me-2 mb-2">
            <Dropdown.Toggle
              variant="light"
              style={{
                border: "1px solid #e5e7eb",
                background: "#fff",
                fontSize: "14px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <FiUpload style={{ marginRight: "6px" }} />
              Export
            </Dropdown.Toggle>

            <Dropdown.Menu align="end">
              <Dropdown.Item>Export as PDF</Dropdown.Item>
              <Dropdown.Item>Export as Excel</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>

          {/* ADD PLAN */}
          <Button
            onClick={() => setAddNewPlan(true)}
            className="me-2 mb-2 d-flex align-items-center"
            style={{
              background: "#f97316",
              border: "none",
              fontSize: "14px",
              fontWeight: "500",
            }}
          >
            <FiPlusCircle style={{ marginRight: "6px" }} />
            Add New Plan
          </Button>

          {/* COLLAPSE */}
          {/* <Button
          variant="light"
          className="mb-2"
          style={{
            border: "1px solid #e5e7eb",
            background: "#fff",
          }}
        >
          <FiChevronUp />
        </Button> */}
        </div>
      </div>
      <PlansSummary />
      <PlansList plans={plans} setPlans={setPlans} />
     <AddNewPlanModal
  show={addNewPlan}
  onHide={() => setAddNewPlan(false)}
  profileImage={profileImage}
  handleFileChange={handleFileChange}
  handleCancelImage={handleCancelImage}
  planFormData={planFormData}
  handleFormChange={handleFormChange}
/>
    </div>
  );
};

export default PackagesPages;
